import { render } from "./AgentTable.vue?vue&type=template&id=0f3c2a1d"
import script from "./AgentTable.vue?vue&type=script&lang=js"
export * from "./AgentTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__